import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RegistrationComponent } from './registration.component';
import { ActivationCodeModule } from './activation-code/activation-code.module';
import { RegistrationTypeModule } from './registration-type/registration-type.module';
import './registration.scss';
import { AccountDataModule } from './account-data/account-data.module';
import { OrganizationDataModule } from './organization-data/organization-data.module';
import { OrganizationDataLpModule } from './organization-data-lp/organization-data-lp.module';
import { SummaryModule } from './summary/summary.module';
import { ActivateModule } from './activate/activate.module';
import { PasswordRecoverModule } from './password-recover/password-recover.module';
import { PaypalSuccessModule } from './paypal-success/paypal-success.module';
import { PaypalCancelModule } from './paypal-cancel/paypal-cancel.module';
import { ContractStep1Module } from './contract-step1/contract-step1.module';
import { ContractStep2Module } from './contract-step2/contract-step2.module';
import { AddPersonalFiles2Controller } from './add-person-files2.controller';
import { ActivationMailSentModalModule } from './activation-mail-sent-modal/activation-mail-sent-modal.module';
import { SignContractModalModule } from './sign-contract-modal/sign-contract-modal.module';
import { UploadPersonalFilesModule } from './upload-personal-files/upload-personal-files.module';
import { SubscriptionModule } from './subscription/subscription.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration', {
            url: '/registration',
            'views': {
                'multiContent': {
                    template: '<registration flex="100"></registration>'
                }
            },
            abstract: true,
            ncyBreadcrumb: {
                label: 'REGISTRAZIONE'
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RegistrationModule: string = ng
    .module('archiSmall.registration', [
        'ui.bootstrap',
        uiRouter,
        ActivationCodeModule,
        RegistrationTypeModule,
        AccountDataModule,
        OrganizationDataModule,
        OrganizationDataLpModule,
        SummaryModule,
        ActivateModule,
        PasswordRecoverModule,
        PaypalSuccessModule,
        PaypalCancelModule,
        ContractStep1Module,
        ContractStep2Module,
        ActivationMailSentModalModule,
        SignContractModalModule,
        UploadPersonalFilesModule,
        SubscriptionModule
    ])
    .component('registration', RegistrationComponent)
    .controller('AddPersonalFiles2Controller', AddPersonalFiles2Controller)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration.module.ts